import React from "react";
import "../styles/notification.css";

function Notification({ notification }) {
  return <div className="notification">{notification}</div>;
}

function TopNotification({ notification, color }) {
  return <div className={`topNotification ${color}`}>{notification}</div>;
}

export { Notification, TopNotification };
